@if (notice; as n) {
  <div class="alert d-flex align-items-start gap-2 mb-3" role="alert"
       [class.alert-warning]="isConsent()" [class.alert-info]="!isConsent()">
    <acc-icon [name]="isConsent() ? 'warn' : 'info'"/>
    <div class="flex-grow-1">
      <div class="fw-bold">{{ n.textKey + '.title'|translate }}</div>
      <div>{{ n.textKey + '.text'|translate }}</div>

      @if (!isConsent()) {
        <!-- 🔴 Eine INFO nimmt JEDER zur Kenntnis - der Endpunkt verlangt dafuer nur ANY:R.
             'Darf Vertraege schliessen' und 'darf eine Mitteilung zur Kenntnis nehmen' sind zweierlei;
             wer beides verwechselt, sperrt die Mitteilung nach § 7 Abs. 4 fuer genau die Leute aus,
             an die sie sich richtet - und das Banner kaeme fuer sie ewig wieder. -->
        <div class="mt-2 d-flex gap-2 flex-wrap">
          <button type="button" class="btn btn-sm btn-primary" (click)="acknowledge()">
            {{ 'notice.action.acknowledge'|translate }}
          </button>
          @if (n.objection) {
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="object()">
              {{ 'notice.action.object'|translate }}
            </button>
          }
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="dismiss()">
            {{ 'notice.action.later'|translate }}
          </button>
        </div>
      } @else if (n.canSign) {
        <!-- Zeichnungsberechtigt: der Weg zur Unterschrift. Der Volltext steht auf der Vertragsseite,
             nicht hier - vier Vertraege in einem Banner waeren unbedienbar. -->
        <div class="mt-2 d-flex gap-2 flex-wrap">
          <a class="btn btn-sm btn-primary" [routerLink]="agreementPath">{{ 'notice.action.sign'|translate }}</a>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="dismiss()">
            {{ 'notice.action.later'|translate }}
          </button>
        </div>
      } @else {
        <!-- Nicht zeichnungsberechtigt: der Hinweis muss einen gangbaren Weg zeigen (Abschnitt 2.1),
             sonst richtet er sich an jemanden, der nichts tun kann. -->
        <div class="mt-2">
          <div>{{ 'notice.hint.notAllowed'|translate }}</div>
          @if (hasSignatories()) {
            <ul class="mb-2 mt-1">
              @for (signatory of n.signatories; track signatory.name) {
                <li>{{ signatory.name }}</li>
              }
            </ul>
            <div class="d-flex gap-2 flex-wrap">
              <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="reminding" (click)="remind()">
                {{ 'notice.action.remind'|translate }}
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="dismiss()">
                {{ 'notice.action.later'|translate }}
              </button>
            </div>
          } @else {
            <!-- ⛔ Der Fall, den 4.1 als Totalausfall benennt: niemand in dieser Organisation darf zeichnen.
                 Statt einer Sackgasse der Weg nach aussen. -->
            <div class="fw-bold mt-1">{{ 'notice.hint.noSignatory'|translate }}</div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Der Widerspruch nach § 7 Abs. 5 - eine Erklaerung mit Rechtsfolge, deshalb mit Begruendung und ohne
     Selbstschliessung: Eine leere Eingabe darf nicht wortlos verworfen werden. -->
<acc-modal #objectionModal type="input"
           [config]="objectionConfig"
           [title]="'notice.action.object'|translate"
           (accConfirmed)="confirmObjection()">
  <label class="form-label" for="objectionReason">{{ 'notice.action.object.reason'|translate }}</label>
  <textarea id="objectionReason" class="form-control" rows="4" maxlength="1000"
            [(ngModel)]="objectionReason" [attr.aria-invalid]="hasNoReason()"></textarea>
  @if (hasNoReason()) {
    <!-- Der vorhandene Hausschluessel statt eines eigenen: Er steht in beiden Sprachen und meint genau das. -->
    <div class="form-text text-danger">{{ 'form.required.label'|translate }}</div>
  }
</acc-modal>
